import { requestJson } from '@vfde-sails/utils';
import { JarvisHomebox, JarvisResponse } from '../interface';
import { getUrl } from './url';
import { Domains, Endpoints } from '../enum';
import { getCMSConfig } from './cms';

const postOptions: RequestInit = {
    headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': 'KSZZFe5MPWBLc3cLUPs2zW5at1w7xQyg',
    },
    method: 'POST',
};

/**
 * Get router details from Jarvis
 * @throws {ApiErrorResponseWithCode} - if the server returns with error
 * @returns {Promise<JarvisHomebox[]>} - A Promise which resolves to an array of JarvisHomebox
 */
export const getJarvisRouters = async (): Promise<JarvisHomebox[]> => {
    const url = getUrl(Domains.VF + Endpoints.JARVIS);
    const payload = {
        id: Object.values(getCMSConfig().routerIds),
    };

    const { body } = await requestJson<JarvisResponse>(url, {
        ...postOptions,
        body: JSON.stringify(payload),
    });

    return body?.products || [];
};
